import classnames from 'classnames';
import React from 'react';
import { withRouter } from 'react-router';
import { isBranch } from '../../../utils/locationUtils';
import { ActiveLink } from '../ActiveLink';
import { connectStore } from '../../appContext/StoreProvider/ConnectStore';
import { MenuTopSections } from './MenuTopSections';
import style from './NavigationMenu.scss';
import { TreeMenus } from './TreeMenus';
import { getIsNavigatedWithMenuLinks } from './utils';
import { withExperiments } from '@wix/wix-experiments-react';

class NavigationMenu extends React.Component {
  constructor(props) {
    super(props);
    this.menuRef = React.createRef();
  }

  syncMenuWithView = (activeLink) => {
    try {
      const isNavigatedWithMenuLinks = getIsNavigatedWithMenuLinks(
        this.props.location,
      );
      if (activeLink && !isNavigatedWithMenuLinks) {
        const currentlyActiveLinkElement =
          document.querySelector(
            `nav a[href^="${activeLink.split('#')[0]}?"]`, // question mark is for case we are in branch/localViewer
          ) || document.querySelector(`nav a[href="${activeLink}"]`);
        if (currentlyActiveLinkElement) {
          const scrollOffset = 100;
          const elementPosition = this.getOffsetFromNav(
            currentlyActiveLinkElement,
            0,
          );
          const offsetPosition = elementPosition - scrollOffset;

          const menuElement = document.querySelector(
            `nav[data-hook="nav-menu"]`,
          );
          menuElement.scrollTo({ top: offsetPosition });
        }
      }
    } catch (err) {
      // TODO: handle query failure selector properly
    }
  };

  isSubMenuTitle = (node) =>
    node && node.dataset && node.dataset.hook === 'sub-menu-title';

  isNodeOfTypeNav = (node) => node && node.nodeName === 'NAV';

  getOffsetFromNav = (linkElement, offsetTopFromDeeperLevels) => {
    const { offsetParent, offsetTop } = linkElement;
    const currentLevelOffsetTop = offsetTop + offsetTopFromDeeperLevels;
    const isFirstLevelMenuLink = this.isNodeOfTypeNav(offsetParent);
    if (isFirstLevelMenuLink) {
      return currentLevelOffsetTop;
    }
    return this.getOffsetFromNav(offsetParent, currentLevelOffsetTop);
  };

  handleMenuClick = (e) => {
    if (this.isSubMenuTitle(e.target) || this.isNodeOfTypeNav(e.target)) {
      return;
    }
    this.props.closeMenu();
  };

  render() {
    const { store } = this.props;

    const classes = classnames({
      [style.leftMenu]: true,
      [style.hamburgerMenu]: this.props.isHamburgerMenuOpen,
      [style.hasRelatedSitesComp]:
        store.viewer?.viewerConfig?.relatedSites?.length > 1,
      [style.withNotificationBar]:
        isBranch(this.props.location) || this.props.isPreview,
    });

    return (
      <nav
        className={classes}
        ref={this.menuRef}
        onClick={this.handleMenuClick}
        data-hook="nav-menu"
      >
        <ActiveLink onActiveLinkChange={this.syncMenuWithView}>
          {this.props.store.hasGuides() && (
            <MenuTopSections menuSync={this.syncMenuWithView} />
          )}
          <TreeMenus
            menuSync={this.syncMenuWithView}
            tree={this.props.store.docsTree}
          />
        </ActiveLink>
      </nav>
    );
  }
}

export default withExperiments(withRouter(connectStore(NavigationMenu)));
